import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Toast, ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {

  blogs: any = [];
  blog: any = {};
  blogId: any = '';
  recentBlogs: any = [];
  cate: any = [];
  categories: any = {};
  categoryList: any = [];
  siteUrl = environment.siteUrl;
  newComment: string = '';
  comments: any = [];
  commentName: string = '';
  commentEmail: string = '';

  constructor(private appService: AppService, private activeRoute: ActivatedRoute, private toastrService: ToastrService, private router: Router) {
    this.activeRoute.params.subscribe((res: any) => {
      this.blogId = res.blogId;
      this.getBlogInfo();
    })
  }

  ngOnInit() {
    this.commentName = sessionStorage.getItem('userName')|| '';
    this.commentEmail = sessionStorage.getItem('email') || '';
    this.appService.getBlogs().subscribe((res: any) => {
      this.blogs = res;
      this.recentBlogs = JSON.parse(JSON.stringify(res)).splice(0, 4);
      this.blogs.forEach((item: any) => {
        if (!this.categories[item.category]) {
          this.categories[item.category] = 1;
        } else {
          this.categories[item.category] += 1;
        }
      });
      this.categoryList = Object.keys(this.categories);
    })
    this.newComment = sessionStorage.getItem('pendingComment') || '';
  }

  getBlogInfo() {
    this.appService.getBlogDetails(this.blogId).subscribe((res: any) => {
      this.blog = res;
    })
    this.appService.getAnswersDetails(this.blogId).subscribe((res: any) => {
      this.comments = res;
    })
  }

  addComment() {
    if (this.commentEmail && this.commentName && this.newComment) {
      this.commentEmail = this.commentEmail.trim();
      this.commentName = this.commentName.trim();
      this.newComment = this.newComment.trim();
      if (!this.commentEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        this.toastrService.error('Please enter a valid email address.', 'Error');
        return;
      }
      if (this.commentEmail.length > 50) {
        this.toastrService.error('Email address should not exceed 50 characters.', 'Error');
        return;
      }
      if (this.commentName.length > 50) {
        this.toastrService.error('Name should not exceed 50 characters.', 'Error');
        return;
      }
      if (this.newComment.length > 500) {
        this.toastrService.error('Comment should not exceed 500 characters.', 'Error');
        return;
      }
    }
    if (sessionStorage.getItem('access_token')) {
      console.log("Got in")
      let body = {
        "answer": this.newComment,
        "name": this.commentName,
        "email": this.commentEmail,
        "type": "BLOG",
        "item_id": this.blogId,
        "status": "Active",
        "createdBy": sessionStorage.getItem('loginId') || 'd1eb5bd2-a6e3-48dd-a22f-a397477f9d9d',
        "createdAt": new Date().toISOString().substring(0, 10),
        "updatedBy": sessionStorage.getItem('loginId') || 'd1eb5bd2-a6e3-48dd-a22f-a397477f9d9d',
        "updatedAt": new Date().toISOString().substring(0, 10)
      }
      this.appService.saveAnswersDetails(body).subscribe((res: any) => {
        this.appService.getAnswersDetails(this.blogId).subscribe((res: any) => {
          this.newComment = '';
          this.commentName = sessionStorage.getItem('userName')|| '';
          this.commentEmail = sessionStorage.getItem('email') || '';
          
          this.appService.getAnswersDetails(this.blogId).subscribe((res: any) => {
            this.comments = res;
          });
        })
      })
    } else {
      sessionStorage.setItem('pendingComment', this.newComment);
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
    }
  }

}
